export const getState = (name) => {
    const state = localStorage.getItem(name);

    if(state){
        return JSON.parse(state);
    }

    return null;
}

export const isHideColumnGridData = (field, name) => {
    let localStorage = getState(name) || {};
    const state = localStorage.columns;
    if(!state) return false;

    return state[field] ? state[field].hide : false;
}

export const updateHideColumnGridData = (data, name) => {
    let localStorage = getState(name) || {};
    const state = localStorage.columns;

    if(!state) return data;

    for(let i in state){
        data.forEach((column) => {
            if(column.field === i){
                column.hide = state[i].hide;
            }
        })
    }

    return data;
}

export const updateShowColumnGridData = (name) => {
    let localStorage = getState(name) || {};
    const state = localStorage.columns;

    for(let i in state){
        state[i].hide = false;
    }

    return state;
}

export const updateState = (e, name) => {
    let state = getState(name) || {};
    state = {...state, ...e}

    localStorage.setItem(name , JSON.stringify(state));
}

export const removeState = (name) => {
    localStorage.removeItem(name);
}




